export default __webpack_public_path__ + "static/dialog-browser-47a54c575375de914313dbd70efe2c8e.png";